/**
 * Initialization for Live Preview SDK
 * Values must be set on window object so this can initialize when ready
 */
import ContentstackLivePreview from '@contentstack/live-preview-utils';

export function initLivePreview(key: string, env: string)
{
  if (key?.length && env?.length)
  {
    console.info('Initializing Live Preview Support');

    ContentstackLivePreview.init({
      enable: true,
      ssr: true,
      mode: 'preview',
      // Recommended: Enables Edit Tags
      editButton: { enable: false },
      stackDetails: {
        apiKey: key,
        environment: env,
      },
    });
  }
}
